import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from '@angular/material/dialog';
import { UserModel } from 'app/_models/user-model';
import { UserProfile } from 'app/_models/users';
import { AccountService } from 'app/_services/account.service';
declare const swal: any;
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html'
})
export class UserProfileComponent implements OnInit {
  isLoaderResult :boolean = false;
  currentUser: UserModel;
  userProfile: UserProfile;
  constructor(
    private readonly dialogRef: MatDialogRef<UserProfileComponent>,
    private readonly accountService: AccountService
  ) { 
    this.currentUser = JSON.parse(sessionStorage.getItem('user'));

  }

  ngOnInit(): void {
   
    this.isLoaderResult = true;
    this.accountService.getUserProfile(this.currentUser.userId).subscribe(
      (data) => {
 
        this.isLoaderResult = false;
        if (data.didError) {
          this.isLoaderResult = false;
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          this.isLoaderResult = false;
           this.userProfile = data.model;
        }
      },
      (error) => {
        this.isLoaderResult = false;
        if (error) {
          swal({
            title: "",
            text: error.error,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: "Somthing went wrong. Please contact admin",
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      }
    );
  }

  close()
  {
    this.dialogRef.close();
  }

}
